export const MAX_UPLOAD_BYTES = Math.floor(1.5 * 1024 * 1024);

const loadImage = (file) =>
  new Promise((resolve, reject) => {
    const url = URL.createObjectURL(file);
    const img = new Image();
    img.onload = () => { URL.revokeObjectURL(url); resolve(img); };
    img.onerror = () => { URL.revokeObjectURL(url); reject(new Error("image load failed")); };
    img.src = url;
  });

const toBlob = (canvas, quality) =>
  new Promise((resolve) => canvas.toBlob(resolve, "image/jpeg", quality));

// Re-encodes heavy JPG/PNG images as JPEG, scaling down until under the limit.
export const compressImageIfNeeded = async (file, limit = MAX_UPLOAD_BYTES) => {
  if (!/^image\/(jpeg|png)$/.test(file.type) || file.size <= limit) return file;

  const img = await loadImage(file);
  const canvas = document.createElement("canvas");
  const ctx = canvas.getContext("2d");
  let scale = Math.min(1, 2400 / Math.max(img.width, img.height));

  for (let attempt = 0; attempt < 8; attempt++) {
    canvas.width = Math.round(img.width * scale);
    canvas.height = Math.round(img.height * scale);
    ctx.fillStyle = "#fff";
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

    for (const quality of [0.85, 0.75, 0.65, 0.55]) {
      const blob = await toBlob(canvas, quality);
      if (blob && blob.size <= limit) {
        const name = file.name.replace(/\.(png|jpe?g)$/i, "") + ".jpg";
        return new File([blob], name, { type: "image/jpeg", lastModified: Date.now() });
      }
    }
    scale *= 0.75;
  }
  return file;
};
